import { HStack, Icon } from "@/shared/ui/primitives";
import { hasAppHistory } from "@/shared/lib/router";
import { useRouter } from "@tanstack/react-router";
import { motion } from "framer-motion";

export interface BackButtonProps {
	label: string;
}

export const BackButton = (p: BackButtonProps) => {
	const router = useRouter();
	if (!hasAppHistory()) return null;

	return (
		<motion.button
			onClick={() => router.history.back()}
			type="button"
			className="fixed top-[20px] left-[20px] z-10 rounded-[12px]"
			whileHover={{ scale: 1.04, background: "var(--hover)" }}
			transition={{ scale: { duration: 0.2 }, background: { duration: 0 } }}
		>
			<HStack className="gap-[6px] p-[10px] md:pl-[12px] md:pr-[16px] text-ct-regular text-lg font-medium">
				<Icon name="Back" width={22} height={22} />
				<span className="hidden md:inline">{p.label}</span>
			</HStack>
		</motion.button>
	);
};
